import React, { useState } from 'react';

export default function Main() {
    const [user] = useState("")

    return (
        <h1>
            Welcome, { user }
        </h1>
    )
}

